// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2qxEm","right":"Footer_right__3K3iK","buttons":"Footer_buttons__3a7bN"};